// import React from "react";

// function PerpetualSwaps() {
//   return (
//     <>
//       <div className="award-style-one-area default-padding">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 offset-lg-2">
//               <div className="site-heading text-center">
//                 <h4 className="sub-title">Achivement &amp; Awards</h4>
//                 <h2 className="title split-text-right split-text-in-right split-lines">
//                   What does the Crypto Derivatives Exchange offer
//                 </h2>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="award-style-one-items">
//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>Futures & Options Trading</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Provides a variety of derivative products, such as futures
//                       contracts and options (right to buy/sell without
//                       obligation), allowing traders to speculate on crypto
//                       investments.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>01</h2>
//                   </div>
//                 </div>

//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/2.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>Perpetual Swaps</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Enables continuous trading of cryptocurrency contracts
//                       without an expiration date, allowing traders to hold
//                       positions indefinitely and benefit from price
//                       fluctuations.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>02</h2>
//                   </div>
//                 </div>

//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/3.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>Leverage Trading</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Offers leveraged positions, allowing traders to borrow
//                       capital to increase their exposure to the market,
//                       magnifying both potential profits and risks.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>03</h2>
//                   </div>
//                 </div>

//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/4.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>Risk Management Tools</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Provides features like stop-loss orders, take-profit
//                       orders, and margin calls to help users manage risk
//                       effectively and minimize losses during volatile market
//                       conditions.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>04</h2>
//                   </div>
//                 </div>
//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>High Liquidity & Low Slippage</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Ensures that there is sufficient liquidity to execute
//                       large trades quickly with minimal price impact, reducing
//                       slippage and providing better trade execution for users.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>05</h2>
//                   </div>
//                 </div>
//                 <div className="award-style-one-item hover-active-item">
//                   <div className="image-wrapper">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/brand/4.jpg"
//                       alt="Image Not Found"
//                     />
//                   </div>
//                   <div className="title">
//                     <h4>Advanced Charting & Analytics`</h4>
//                   </div>
//                   <div className="info">
//                     <p>
//                       Offers sophisticated tools for technical analysis,
//                       including real-time data, customizable charts, and various
//                       indicators to help traders make informed decisions.
//                     </p>
//                   </div>
//                   <div className="year">
//                     <h2>06</h2>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default PerpetualSwaps;

import React from "react";
import {
  FaChartLine,
  FaSyncAlt,
  FaBalanceScale,
  FaShieldAlt,
  FaWater,
  FaChartBar,
} from "react-icons/fa";

function PerpetualSwaps() {
  const data = [
    {
      icon: <FaChartLine />,
      title: "Futures & Options Trading",
      desc: "Provides a variety of derivative products, such as futures contracts and options allowing traders to speculate on crypto investments.",
    },
    {
      icon: <FaSyncAlt />,
      title: "Perpetual Swaps",
      desc: "Enables continuous trading of cryptocurrency contracts without an expiration date and allows long-term positions.",
    },
    {
      icon: <FaBalanceScale />,
      title: "Leverage Trading",
      desc: "Offers leveraged positions to increase exposure, amplifying both potential profits and risks.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Risk Management Tools",
      desc: "Includes stop-loss, take-profit, and margin control tools to minimize trading risks.",
    },
    {
      icon: <FaWater />,
      title: "High Liquidity & Low Slippage",
      desc: "Ensures fast trade execution with minimal price impact and better market stability.",
    },
    {
      icon: <FaChartBar />,
      title: "Advanced Charting & Analytics",
      desc: "Provides real-time data, technical indicators, and customizable charts for smarter decisions.",
    },
  ];

  return (
    <div className="award-style-one-area default-padding bg-light">
      <div className="container">
        {/* HEADING */}
        <div className="text-center mb-5">
          <h4 className="sub-title">Features</h4>
          <h2 className="title">
            What does the Crypto Derivatives Exchange offer
          </h2>
        </div>

        {/* GRID */}
        <div className="row g-4">
          {data.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="feature-card">
                {/* ICON */}
                <div className="pb-10">
                  <div className="icon-box">{item.icon}</div>
                </div>

                {/* CONTENT */}
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PerpetualSwaps;
